/* eslint-disable default-case */
import React, { PureComponent } from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Scrollbars} from 'react-custom-scrollbars';
import './assets/style.scss';
import * as Actions from "../../../../actions";

class Cart extends PureComponent {

  constructor(props) {
    super(props);

    this.tabs = [
        {
          key: 'cart',
          label: 'Избранное'
        },
        {
          key: 'items',
          label: 'На площадке'
        }
    ]

    this.state = {
      isOpen: true,
      currentTab: 'cart'
    };

    this.handleToggle = this.handleToggle.bind(this);
  }

  handleToggle = (e) => {
    const toggled = !this.state.isOpen;
    this.setState({isOpen: toggled});
  }

  componentDidMount = () => {

  };

  changeTab = (currentTab) => {
    this.setState({currentTab})
  };

  getItems = () => {

    return this.props[this.state.currentTab]
  };

  removeItem = (index) => {
    switch (this.state.currentTab ) {
      case 'cart':
        this.props.removeFromCart(index);
        break;
      case 'items':
        this.props.removeItem(index);
        this.forceUpdate();
        break;
    }
  };


  render() {
    const items = this.getItems();
    const cls = 'Constructor-Cart' + (this.state.isOpen ? ' open' : '');

    return (<aside className={cls}>
      <div className="Constructor-Cart-Title" onClick={this.handleToggle}>
        <span className="Constructor-Cart-Title-Logo"/>
        <div className="Constructor-Cart-Title-Text_vertical">
          М О Я<br/><br/>П Л О Щ А Д К А
        </div>
        <i className="icon-arrow-right"/>
      </div>
      <div className="Constructor-Cart-Container">

        <div className="Constructor-Cart-Container-Header" onClick={this.handleToggle}>
          <div>
            <h4>Моя площадка <i className="icon-arrow-right"/></h4>
          </div>
        </div>

        <div className="Constructor-Cart-Container-Content">

          <ul className="Constructor-Cart-Container-Content-Tab-Nav">
            {this.tabs.map((tab) => {
              const cls = this.state.currentTab  === tab.key ? 'active' : '';
              return (<li key={tab.key} className={cls} onClick={this.changeTab.bind(this, tab.key)} >
                <span>{tab.label}</span>
              </li>)
            })}
          </ul>

          <div className="Constructor-Cart-Container-Content-Tab-Content">
            <div className="Constructor-Cart-Container-Content-Tab-Content-Scroll">
              <Scrollbars
                  autoHide
                  className="Constructor-Cart-Container-Content-Tab-Content-Scroll-Content"
                  renderTrackVertical={(style, ...props) => {
                    return (
                        <div className="Constructor-Cart-Container-Content-Tab-Content-Scroll-Scroller" style={style}{...props}/>
                    );
                  }}
                  renderThumbVertical={(style, ...props) => {
                    return (
                        <div style={style}{...props}/>
                    );
                  }}
              >
                <ul className="list-unstyled">
                  {Object.keys(items).map((id) => {
                    const item = items[id];
                    return <li key={`itemInCart_${id}`}>
                      <span onClick={() => {this.props.addItem(item)}} className="App-Item-Thumb">
                        <img src={item.thumb} alt={item.name}/>
                      </span>
                      <span>
                        <span onClick={() => {this.props.addItem(item)}}>
                          <h6>
                            <small>{item.article}</small> {item.name}
                          </h6>
                        </span>
                        <span onClick={() => {this.removeItem(id);}}>удалить <i className="icon-remove"/> </span>
                      </span>
                    </li>
                  })}
                </ul>
              </Scrollbars>
            </div>
          </div>
        </div>
      </div>
    </aside>);
  }
}

export default connect(
    (state) => {
      return {
        cart: state.cart,
      };
    },
    (dispatch) => bindActionCreators({
      removeFromCart: Actions.cart.remove,
    }, dispatch),
)(Cart);
